/* eslint-disable import/prefer-default-export */
import { apiCaller } from 'src/util/apiCaller';

const newNguoiDung = function* newNguoiDung(item) {
  const configAPI = {
    url: 'api/nguoidungs/create',
    method: 'POST',
    data: item
  };
  const data = apiCaller(configAPI);
  return yield data || [];
};

const deleteNguoiDung = function* deleteNguoiDung(id) {
  const configAPI = {
    url: `api/nguoidungs/${id}`,
    method: 'DELETE'
  };
  const data = apiCaller(configAPI);
  return yield data || [];
};

export const NguoiDungsAPI = {
  newNguoiDung,
  deleteNguoiDung
};
